import React from 'react'
import { assets } from '../assets/assets'
import { Helmet } from 'react-helmet-async';

const OurPolicy = () => {
  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Our Policy - Hassle-Free Returns, Easy Exchanges, and Support</title>
        <meta 
          name="description" 
          content="Learn about our hassle-free exchange and return policies, along with our 24/7 customer support. Shop with confidence and ease!" 
        />
        <meta 
          name="keywords" 
          content="exchange policy, return policy, hassle-free returns, easy exchange, 7 days return, customer support, best support, 24/7 support, policy for returns, exchange terms" 
        />
      </Helmet>
    
    <div className='flex flex-col sm:flex-row justify-around gap-12 sm:gap-2 text-center py-20 text-xs sm:text-sm md:text-base text-gray-700'>
      
      <div>
        <img src={assets.exchange_icon} className='w-12 m-auto mb-5' alt="" />
        <p className=' font-semibold'>Easy Exchange Policy</p>
        <p className=' text-gray-400'>We offer hassle free  exchange policy</p>
      </div>
      <div>
        <img src={assets.quality_icon} className='w-12 m-auto mb-5' alt="" />
        <p className=' font-semibold'>7 Days Return Policy</p>
        <p className=' text-gray-400'>We provide 7 days free return policy</p>
      </div>
      <div>
        <img src={assets.support_img} className='w-12 m-auto mb-5' alt="" />
        <p className=' font-semibold'>Best customer support</p>
        <p className=' text-gray-400'>we provide 24/7 customer support</p>
      </div>

    </div>

    </>
  )
}

export default OurPolicy
